import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
  selector: '[errorState]'
})
export class ErrorStateDirective {
  @Input('errorState') inValid: boolean

  @HostBinding('class.interval-required')
  get intervalRequiredClass() {
    if (this.inValid === undefined || this.inValid === null) return true
    return false
  }

  @HostBinding('class.interval-error')
  get intervalErrorClass() {
    return this.inValid == true
  }

  @HostBinding('hidden')
  get hidden() {
    return this.inValid === false
  }
}